import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Injectable()
export class LocalStorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }

  /**
   * @param {String} name The name of the property to set
   * @param {String} value The value to use when setting the specified property
   */
  set(name, value) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(name, value);
    }
  }

  /**
   * @param {String} name The name of the value to retrieve
   * @return {?String} The value of the
   */
  get(name) {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    return localStorage.getItem(name) || null;
  }

  /**
   * @param {String} name The name of the value to delete/remove from storage
   */
  remove(name) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(name);
    }
  }

}
